import { gql } from "@apollo/client";

export const CREATE_CLIENT_COMMENT = gql`
  mutation CreateClientComment($clientId: Int!, $text: String!) {
    createClientComment(clientId: $clientId, text: $text) {
      id
      text
      user {
        id
        userName
      }
      createdAt
      updatedAt
    }
  }
`;
